import React from "react";

function CitiesPage() {
  const containerStyle = {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "2rem",
  };

  const headingStyle = {
    marginBottom: "1rem",
  };

  const subheadingStyle = {
    marginTop: "1.5rem",
    marginBottom: "0.75rem",
  };

  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>Offres Baltee Mobility pour les Villes</h1>

      <p>
        <strong>Baltee Mobility</strong> s’engage à soutenir les municipalités dans leurs
        démarches de mobilité durable. Grâce à nos appareils connectés et nos
        solutions de gestion, nous aidons les villes à réduire la congestion,
        à favoriser la transition écologique et à améliorer la qualité de vie
        des habitants.
      </p>

      <h2 style={subheadingStyle}>Pourquoi choisir Baltee Mobility pour votre ville&nbsp;?</h2>
      <ul>
        <li>
          <strong>Réduction de la circulation automobile</strong> : Nos solutions de 
          micro-mobilité encouragent les déplacements actifs et partagés, contribuant 
          à désengorger les centres-villes et à limiter la pollution.
        </li>
        <li>
          <strong>Gestion de flotte centralisée</strong> : Grâce à notre plateforme 
          connectée, les municipalités peuvent superviser l’ensemble des véhicules 
          (B01, etc.), suivre leur utilisation et optimiser leur 
          répartition sur le territoire.
        </li>
        <li>
          <strong>Sécurité & Respect de l’espace public</strong> : Nos appareils 
          sont équipés de systèmes de verrouillage et de géolocalisation pour 
          garantir une utilisation responsable. Les données collectées permettent 
          d’orienter la planification urbaine et le déploiement d’infrastructures 
          adaptées.
        </li>
        <li>
          <strong>Accompagnement réglementaire</strong> : Nous sommes conscients 
          des défis juridiques et administratifs liés à la mobilité nouvelle 
          (trottinettes, vélos, dispositifs personnels motorisés). Baltee propose son 
          expertise pour aider les municipalités à mettre en place des cadres 
          adaptés.
        </li>
      </ul>

      <h2 style={subheadingStyle}>Nos solutions pour les collectivités</h2>
      <p>
        <strong>Location en libre-service</strong> : Mettez à disposition des usagers 
        un parc de B01 ou B01 Lite, accessible via une application dédiée ou une 
        carte d’abonnement. La gestion est assurée par Baltee ou en partenariat 
        avec la ville.
      </p>
      <p>
        <strong>Partenariats Public-Privé (PPP)</strong> : Nous proposons différents 
        modèles de collaboration (leasing, co-investissement, subventions) pour 
        instaurer un service de mobilité complet, adapté aux besoins des 
        citoyens et aux ressources de la commune.
      </p>
      <p>
        <strong>Personnalisation & Branding</strong> : Chaque flotte peut être 
        personnalisée aux couleurs de la ville, avec la possibilité d’ajouter 
        des messages de sensibilisation ou d’information pour les usagers.
      </p>

      <h2 style={subheadingStyle}>Service Après-Vente & Maintenance</h2>
      <p>
        Les <strong>équipes Baltee</strong> assurent la maintenance préventive et 
        corrective du parc déployé. Grâce à notre réseau national de techniciens 
        et à un système de support à distance, nous intervenons rapidement pour 
        garantir la disponibilité maximale des dispositifs.
      </p>
      <p>
        Pour les municipalités, nous mettons en place des indicateurs de suivi 
        (taux de panne, temps de réparation, nombre d’utilisateurs actifs) afin 
        de mesurer l’efficacité du service et améliorer en continu la 
        satisfaction des citoyens.
      </p>

      <h2 style={subheadingStyle}>Analyse des données et planification urbaine</h2>
      <p>
        Baltee offre un tableau de bord dédié aux collectivités, permettant de 
        visualiser l’utilisation réelle des dispositifs (heures de pointe, zones 
        de stationnement, trajets les plus fréquentés etc.). Ces données peuvent 
        servir à adapter l’aménagement urbain (pistes cyclables, stationnements 
        sécurisés etc.) et à anticiper les besoins futurs.
      </p>

      <h2 style={subheadingStyle}>Comment mettre en place une flotte Baltee&nbsp;?</h2>
      <p>
        Si vous souhaitez déployer une solution Baltee Mobility dans votre ville&nbsp;:
      </p>
      <ol>
        <li>
          <strong>Étude préalable</strong> : Nous analysons vos objectifs, 
          votre environnement et vos contraintes (budget, infrastructure, 
          réglementation).
        </li>
        <li>
          <strong>Proposition de déploiement</strong> : Nous établissons un 
          calendrier, définissons le nombre d’dispositifs requis, la localisation 
          des stations et la stratégie de communication.
        </li>
        <li>
          <strong>Signature du contrat & mise en place</strong> : Nous gérons la 
          logistique, la formation des agents municipaux et le lancement public.
        </li>
        <li>
          <strong>Suivi & ajustements</strong> : Nous restons à l’écoute pour adapter 
          le service aux retours des utilisateurs, aux évolutions réglementaires et 
          aux nouveaux enjeux de la ville.
        </li>
      </ol>

      <h2 style={subheadingStyle}>Contactez-nous</h2>
      <p>
        Vous êtes une collectivité, un syndicat de transport ou un groupement 
        intercommunal&nbsp;? Envoyez-nous un <strong>e-mail</strong> à{" "}
        <a href="mailto:contact@baltee.com">contact@baltee.com</a> 
        ou remplissez notre formulaire de contact disponible dans la rubrique 
        <em>Contact & SAV</em>. Nous serons ravis d’étudier avec vous la meilleure 
        solution de déploiement pour répondre aux enjeux de votre ville.
      </p>

      <p>
        Rejoignez <strong>Baltee Mobility</strong> dans la construction d’un avenir 
        plus vert, plus fluide et plus connecté au sein de nos centres urbains&nbsp;!
      </p>
    </div>
  );
}

export default CitiesPage;
